import { useState } from "react";

/**
 * Saved Generate-page configurations: pick one to re-apply every filter at
 * once, or name the current setup and store it for next close.
 */
function ReportPresetBar({
  presets,
  loading,
  selectedPresetId,
  onApply,
  onSave,
  onDelete,
  error,
  notice,
}) {
  const [naming, setNaming] = useState(false);
  const [name, setName] = useState("");

  const selected = presets.find((p) => p.id === selectedPresetId) || null;

  const submitName = (e) => {
    e.preventDefault();
    const trimmed = name.trim();
    if (!trimmed) return;
    onSave(trimmed);
    setName("");
    setNaming(false);
  };

  const startNaming = () => {
    // Offer the current preset's name so re-saving after a tweak is one click
    setName(selected ? selected.name : "");
    setNaming(true);
  };

  return (
    <div className="preset-bar">
      <div className="preset-bar-row">
        <div className="filter-item">
          <label htmlFor="report-preset">Saved reports</label>
          <select
            id="report-preset"
            value={selectedPresetId || ""}
            disabled={loading || presets.length === 0}
            onChange={(e) => {
              const preset = presets.find((p) => p.id === e.target.value);
              if (preset) onApply(preset);
            }}
          >
            <option value="">
              {loading
                ? "Loading…"
                : presets.length === 0
                  ? "No saved reports yet"
                  : "Choose a saved report…"}
            </option>
            {presets.map((p) => (
              <option key={p.id} value={p.id}>
                {p.name}
              </option>
            ))}
          </select>
        </div>

        {naming ? (
          <form className="preset-name-form" onSubmit={submitName}>
            <div className="filter-item">
              <label htmlFor="preset-name">Name this report</label>
              <input
                id="preset-name"
                type="text"
                value={name}
                maxLength={80}
                autoFocus
                placeholder="e.g. Monthly close – East region"
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <button type="submit" className="preset-btn preset-btn-primary">
              Save
            </button>
            <button
              type="button"
              className="preset-btn"
              onClick={() => {
                setNaming(false);
                setName("");
              }}
            >
              Cancel
            </button>
          </form>
        ) : (
          <div className="preset-actions">
            <button type="button" className="preset-btn" onClick={startNaming}>
              Save current setup
            </button>

            {selected && (
              <button
                type="button"
                className="preset-btn preset-btn-danger"
                onClick={() => {
                  if (
                    window.confirm(`Delete the saved report "${selected.name}"?`)
                  ) {
                    onDelete(selected);
                  }
                }}
              >
                Delete
              </button>
            )}
          </div>
        )}
      </div>

      {notice && <p className="preset-notice">{notice}</p>}
      {error && <p className="preset-error">⚠️ {error}</p>}
    </div>
  );
}

export default ReportPresetBar;
